import PropTypes              from 'prop-types';
import React                  from 'react';
import styles                 from './InputField.scss';

export default class InputField extends React.Component {
  constructor() {
    super();
  }

  changeValue(e) {
    this.props.onChange(e, e.nativeEvent.target.value, (val) => this.validate(val));
  }

  validate(value) {
    if(this.props.validate) {
      for(let i of this.props.validate) {
        if(!i(value)) {
          return false
        }
      }
    }
    return true
  }

  render() {
    return (
      <div className={[styles.inputHolder, (!this.props.valid && this.props.require ? styles.invalid : null), (this.props.pre ? styles.has_pre : null)].join(' ')}>
        {this.props.pre ? <span className={styles.pre}>{this.props.pre}</span> : null}
        <input type={this.props.type || 'text'} value={this.props.value || ''} maxLength={this.props.maxLength || ''} onChange={this.changeValue.bind(this)}/>
        <label>
          { this.props.require ? <span className={styles.red}>* </span> : null }
          {this.props.label}
        </label>
      </div>
    );
  }
}
